'use strict';

import _ from 'lodash';

export default function () {
  return {
    controller: function($scope, $http, $sce, $timeout, $interval, $uibModal) {
      'ngInject';

      $scope.current = 0;


      $scope.$watch("current", function WatchCurrent() {
        $timeout(_setHeight);
      });


      $scope.ItemClick = function ItemClick(item) {
        $uibModal.open({
          templateUrl: 'videoPopupProgramsBoxes',
          size: 'xlg',
          windowClass: 'videoPopup',
          controller: function($scope, $uibModalInstance) {
            $scope.selectedItem = item;
          }
        });
      };

      $(window).resize(_setHeight);

      function _setHeight() {
        var maxHeight = 0;
        $(".ProgramsBoxes .BoxInner").each(function() {
          var height = $(this).innerHeight();
          maxHeight = Math.max(maxHeight, height);
        });

        $(".ProgramsBoxes .Box").height(maxHeight);
      };

      $interval(_setHeight, 500);
    },
    template: require('./programsboxes.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/programsboxes.js